import type { z } from "zod";

import { zOutSchema } from "./common";

import { Response } from "~/shared/api";

const zRes201 = Response.Schema.zSuccessful(201, zOutSchema);
const zRes4xx = Response.Schema.zUnsuccessful2([400, 401]);

const zRes = Response.Schema.zAggregated([zRes201, ...zRes4xx]);
type Res = z.infer<typeof zRes>;

export { zRes };
export type { Res };
